export interface TnsMetadataJson {
  situation?: Record<string, unknown>;
  evaluation?: Record<string, unknown>;
}

export class TnsMetadata {
  constructor(
    public situation?: Record<string, unknown>,
    public evaluation?: Record<string, unknown>
  ) {}

  public static fromJson(json: TnsMetadataJson): TnsMetadata {
    return new TnsMetadata(json.situation, json.evaluation);
  }

  public static toJson(model: TnsMetadata): TnsMetadataJson {
    return {
      situation: model.situation,
      evaluation: model.evaluation
    };
  }
}
